import React from "react";
import { stats } from "../data/content";

const sources = ["Websites & PDPs", "ERP / CRM", "APIs & files"];
const outputs = [
  { icon: "fa-chart-pie", label: "Dashboards" },
  { icon: "fa-code", label: "Data APIs" },
  { icon: "fa-mobile-screen-button", label: "Web & apps" },
];
const bars = [38, 52, 46, 64, 58, 72, 68, 84, 79, 92];

function Hero() {
  return (
    <section id="top" className="hero">
      <div className="hero-grid-bg" aria-hidden="true" />
      <div className="container position-relative">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <p className="eyebrow eyebrow-light">Data services · Web &amp; application development</p>
            <h1 className="hero-title">
              Enterprise data and software, engineered for growth.
            </h1>
            <p className="hero-lead">
              MN2GROW helps organizations collect, structure and activate their data — and builds the
              websites, applications and business systems that run on it.
            </p>
            <div className="hero-actions">
              <a href="#contact" className="btn-corp btn-corp-primary btn-corp-lg">
                Request a consultation <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </a>
              <a href="#services" className="btn-corp btn-corp-ghost btn-corp-lg">
                Explore our services
              </a>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="hero-panel" aria-label="Illustration of an MN2GROW data platform">
              <div className="panel-head">
                <span className="panel-dots" aria-hidden="true"><i /><i /><i /></span>
                <span className="panel-title">Data platform overview</span>
                <span className="panel-status"><span className="pulse" /> Pipelines healthy</span>
              </div>

              <div className="panel-flow">
                <div className="flow-col">
                  <span className="flow-label">Collect</span>
                  {sources.map((s) => (
                    <span className="flow-chip" key={s}>{s}</span>
                  ))}
                </div>
                <div className="flow-arrow" aria-hidden="true"><i className="fa-solid fa-arrow-right" /></div>
                <div className="flow-col flow-core">
                  <span className="flow-label">Engineer</span>
                  <div className="core-box">
                    <span><i className="fa-solid fa-check" /> Clean</span>
                    <span><i className="fa-solid fa-check" /> Validate</span>
                    <span><i className="fa-solid fa-check" /> Enrich</span>
                  </div>
                </div>
                <div className="flow-arrow" aria-hidden="true"><i className="fa-solid fa-arrow-right" /></div>
                <div className="flow-col">
                  <span className="flow-label">Deliver</span>
                  {outputs.map((o) => (
                    <span className="flow-chip flow-chip-out" key={o.label}>
                      <i className={`fa-solid ${o.icon}`} aria-hidden="true" /> {o.label}
                    </span>
                  ))}
                </div>
              </div>

              <div className="panel-chart" aria-hidden="true">
                <div className="chart-head">
                  <span>Data quality trend</span>
                  <span className="chart-tag">Illustrative</span>
                </div>
                <div className="chart-bars">
                  {bars.map((h, i) => (
                    <span key={i} style={{ height: `${h}%` }} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <dl className="hero-stats">
          {stats.map((s) => (
            <div className="hero-stat" key={s.label}>
              <dt>{s.label}</dt>
              <dd>{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}

export default Hero;
